import api from '@utils/http'
/**
 * 获取视频课程分类
 * @param {}  
 */
export const apiVideoClassify = p=>api.post('course/getVideoCourseKind',p)
/**
 * 获取直播课程分类
 * @param {}  
 */
export const apiLiveClassify = p => api.post('course/audioCourse/getAudioCourseKind',p)
/**
 * 获取当前分类下课程列表
 * @param {kind_level,main_id,sub_id,course_type} 
 * kind_level分类等级0,1,2 ;course_type 0点播，1直播 
 */
export const apiCourseList = p=>api.post('course/getCourseList',p)
/**
 * 获取视频课程详情
 * @param {course_id}  
 */
export const apiVideoDesc = p=>api.post('course/getVideoCourseDesc',p)
/**
 * 获取直播课程详情
 * @param {course_id}  
 */
export const apiLiveDesc = p => api.post('course/audioCourse/getAudioCourseDesc',p)
/**
 * 获取视频课章节列表
 * @param {course_id}  
 */
export const apiCourseChapter = p=>api.post('course/getCourseChapter',p)
/**
 * 获取直播课章节列表
 * @param {course_id}  
 */
export const apiLiveChapter = p => api.post('course/audioCourse/getAudioCourseChapter',p)
/**
 * 获取评论列表
 * @param {course_id}  
 */
export const apiCommentList = p=>api.post('courseqa/getCourseQuesAns',p)
/**
 * 评论下方回复
 * @param {course_id,content,root_id,at_id}  
 * root_id回复的id,at_id:
 */
export const apiComment = p=>api.post('courseqa/insertReply',p)
/**
 * 收藏课程
 * @param {course_id,status}  
 * status 0,1 0取消收藏
 */
export const apiCollect = p=>api.post('course/collect/changeCourseCollectStatus',p)
/**
 * 播放视频鉴权
 * @param {course_id,video_id}  
 */
export const apiVideoAuth = p=>api.post('course/checkVideoAuth',p)
/**
 * 跳转直播室鉴权
 * @param {course_id}  
 */
export const apiLiveRoomAuth = p=>api.post('liveCourse/checkLiveUrlToken',p)
/**
 *购买课程，直播、点播 bottomMenuBar
 * @param {open_id,course_id,pay_type,useJF,is_in_wechat}  
 */
export const apiBuyCourse = p=>api.post('pay/buyCourseForApp',p)
/**
 *查找音频课程 
 * @param {key}  
 * key搜索关键字
 */
export const apiFindByName = p => api.post('course/home/findVideoByName', p)
/**
 * @description 获取音频释义
 * @param video_src_id
 */
export const getAudioPoetryBySrcId = p => api.post('course/audioCourse/getAudioPoetryBySrcId', p)
/**
 * 在听 - 添加到在学列表
 */
export const listeningOfAdd = p => api.post('listening/add', p)
/**
 * 在听 - 从在学列表移除
 */
export const listeningOfRemove = p => api.post('listening/remove', p)
/**
 * 在听 - 获取列表
 */
export const listeningOfGet = p => api.post('listening/get', p)
/**
 * 在听 - 鉴权
 */
export const listeningOfCheckAuth = p => api.post('listening/checkAuth', p)